import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "../../../components";
import { MasterAccountSelect } from "../../../components/forms/selects";
import { useClientSetContext } from "../hooks/ClientSetContext";
import ThemedModal from "../../../components/utilities/ThemedModal";

const AddMasterAccountModal = ({ addAccount, ...modalProps }) => {
    const { selectedSet } = useClientSetContext();

    const [selectedAccountId, setSelectedAccountId] = useState(null);

    const { onHide } = modalProps;

    return <Modal centered onHide={onHide} {...modalProps}>
        <ThemedModal.Header closeButton>
            <Modal.Title>Add Master Account</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body>
            <MasterAccountSelect
                label={`Select Master Account to Add to '${selectedSet?.setName}'`}
                placeholder="Search for a Master Account"
                value={selectedAccountId}
                setValue={(selection) => setSelectedAccountId(selection.value)}
                disableAnimations
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" onClick={() => addAccount(selectedAccountId)}>Add</Button>
            <Button variant="light" onClick={onHide}>Cancel</Button>
        </Modal.Footer>
    </Modal>
}

export default AddMasterAccountModal;